import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import { habuColors } from 'Theme';
import { styled } from '@mui/material/styles';


export const StyledMenuHoverOver = styled(MenuItem)({
  '&:hover': {
    backgroundColor: habuColors.secondary[10],
  },
});

export const StyledFormControl = styled(FormControl)({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: habuColors.secondary[60],
    },
  },
});

export const StyledDialogTitle = styled(DialogTitle)({
  margin: '0px',
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});
